// React Component
import React from 'react'
import { useLocation } from 'react-router-dom'

// Tutorial Components
import FirstLoginTutorial from '../components/Tutorial/FirstLoginTutorial'

// interface
interface ChildProps {
    children: React.ReactNode
    /** Classes additionnelles sur le conteneur racine. */
    className?: string
    /** false = hauteur = contenu (ex. page /home), sans min-height viewport. */
    fillViewport?: boolean
}

/** Enlève backdrop / modal-open orphelins (Bootstrap) qui bloquent les clics après navigation SPA. */
function useBootstrapModalStucknessCleanup(): void {
    const location = useLocation()
    React.useLayoutEffect(() => {
        const w = window as unknown as {
            bootstrap?: { Modal?: { getInstance: (el: Element) => { hide: () => void } | undefined } }
        }
        const Modal = w.bootstrap?.Modal
        document.querySelectorAll('.modal.show').forEach((node) => {
            const inst = Modal?.getInstance(node)
            try {
                inst?.hide()
            } catch {
                /* ignore */
            }
        })
        document.querySelectorAll('.modal-backdrop').forEach((b) => b.remove())
        document.body.classList.remove('modal-open')
        document.body.style.removeProperty('overflow')
        document.body.style.removeProperty('padding-right')
    }, [location.pathname, location.search, location.key])
}

const AppLayout = (propos: ChildProps) => {
    const { children, className, fillViewport = true } = propos
    const location = useLocation()
    const [isBack, setIsBack] = React.useState(false)

    useBootstrapModalStucknessCleanup()

    React.useEffect(() => {
        setIsBack(sessionStorage[location.pathname + '_key'] === location.key)
        sessionStorage[location.pathname + '_key'] = location.key
    }, [location])

    if (isBack) {
        window.scrollTo(0, 0)
    }

    const shellClassName = [
        'w-100 newbg-black d-flex flex-column',
        fillViewport ? 'min-vh-100' : 'app-layout-compact',
        className,
    ]
        .filter(Boolean)
        .join(' ')

    return (
        <>
            <div className={shellClassName}>
                {children}
            </div>
            
            {/* [AUTO-START TUTORIELS] Détection première connexion */}
            <FirstLoginTutorial />
        </>
    )
}

export default AppLayout